import React from 'react';
import Bluedots from '../../assets/images/blue_dotes.png'
import feature1a from '../../assets/images/feature1a.png'
import feature1b from '../../assets/images/feature1b.png'
import icon1 from '../../assets/images/feature-icon1.png'
import feature2a from '../../assets/images/feature2a.png'
import feature2b from '../../assets/images/feature2b.png'
import icon2 from '../../assets/images/feature-icon2.png'
import feature3a from '../../assets/images/feature3a.png'
import feature3b from '../../assets/images/feature3b.png'
import icon3 from '../../assets/images/feature-icon3.png'
import Emoji from '../../utils/emoji'


function Task() {
    return (
        <section className="row_am benefits_section task_business task_app_section ">
            <div className="task_block" style={{ top: 230, position: 'sticky' }}>
                <div className="dotes_blue">
                    <img src={Bluedots} alt="image" />
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="task_img" data-aos="fade-in" data-aos-duration={1500}> 
                            <div className="frame_img">
                                <img src={feature1a} alt="image" />
                            </div>
                            <div className="screen_img">
                                <img className="moving_animation" src={feature1b} alt="image"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="task_text">
                            <div className="section_title white_text" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100} >
                                <span className="title_badge">Beneficii cu LUMO</span>
                                <h2>1. Control & Simplitate</h2>
                                <div className='section_text'>
                                    <div className="section_feature"><p>Tot ce ai nevoie pentru a lucra eficient, în ritmul tău</p></div>
                                    <div className="section_feature"><p><Emoji symbol="📲" label="phone" className="emoji" /> Rezervări online, fără apeluri - Clienții rezervă direct din aplicație, fără telefoane sau mesaje</p></div>
                                    <div className="section_feature"><p><Emoji symbol="📅" label="calendar" className="emoji" /> Program configurabil, control total - Tu alegi zilele, orele și pauzele – flexibilitate completă</p></div>
                                    <div className="section_feature"><p><Emoji symbol="🖥" label="computer" className="emoji" /> Panou de control intuitiv - Ai toate informațiile într-un singur loc, ușor de gestionat</p></div>
                                    <div className="section_feature"><p><Emoji symbol="💬" label="chat" className="emoji" /> Chat integrat pentru comunicare rapidă - Discuți direct cu clienții, fără să-ți dai numărul de telefon</p></div>
                                    <div className="section_feature"><p><Emoji symbol="🤝" label="handshake" className="emoji" /> Sprijin constant din partea echipei noastre - Suntem alături de tine la fiecare pas, cu suport real</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="task_block" style={{ top: 230, position: 'sticky' }}>
                <div className="dotes_blue">
                    <img src={Bluedots} alt="image" />
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="task_img" data-aos="fade-in" data-aos-duration={1500}>
                            <div className="frame_img">
                                <img src={feature2a} alt="image" />
                            </div>
                            <div className="screen_img">
                                <img className="moving_animation" src={feature2b} alt="image" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="task_text">
                            <div className="section_title white_text" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100} >
                                <span className="title_badge">Beneficii cu LUMO</span>
                                <h2>2. Vizibilitate & Creștere</h2>
                                <div className='section_text'>
                                    <div className="section_feature"><p>Te facem ușor de găsit și te ajutăm să crești</p></div>
                                    <div className="section_feature"><p><Emoji symbol="📍" label="pin" className="emoji" /> Vizibilitate locală – în orașul tău - Apari în fața clienților care caută servicii exact în zona ta</p></div>
                                    <div className="section_feature"><p><Emoji symbol="📸" label="camera" className="emoji" /> Pachet opțional de promovare social media - Primești conținut foto/video profesional, creat de echipa LUMO</p></div>
                                    <div className="section_feature"><p><Emoji symbol="✉" label="envelope" className="emoji" /> SMS & email marketing automat pentru clienții tăi - Reamintim clienților de tine prin campanii automate</p></div>
                                    <div className="section_feature"><p><Emoji symbol="🔒" label="lock" className="emoji" /> Fără comisioane - Păstrezi 100% din venitul generat. LUMO nu reține comision din programările făcute prin aplicație – plătești doar abonamentul lunar</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="task_block" style={{ top: 230, position: 'sticky' }}>
                <div className="dotes_blue">
                    <img src={Bluedots} alt="image" />
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="task_img" data-aos="fade-in" data-aos-duration={1500}>
                            <div className="frame_img">
                                <img src={feature3a} alt="image" />
                            </div>
                            <div className="screen_img">
                                <img className="moving_animation" src={feature3b} alt="image" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="task_text">
                            <div className="section_title white_text" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100} >
                                <span className="title_badge">Beneficii cu LUMO</span>
                                <h2>3. Încredere & Loialitate</h2>
                                <div className='section_text'>
                                    <div className="section_feature"><p>Construiești relații mai bune, fără efort</p></div>
                                    <div className="section_feature"><p><Emoji symbol="🎁" label="gift" className="emoji" /> LUMO Rewards - Clienți fideli, ei sunt motivați să revină prin puncte și vouchere</p></div>
                                    <div className="section_feature"><p><Emoji symbol="👥" label="persons" className="emoji" /> Feedback real de la clienți - Primești recenzii care îți consolidează reputația</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </section>
    );
}

export default Task;
